import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import DownloadedDotsBlock from "./downloadedDotsBlock";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";
import CommunityTemplatesOrderSelect from "./communityTemplatesOrderSelect";
import { useOrderTemplates } from "../../../../customHooks";
import CategoriesFilters from "../categoriesFilters";
import { intersectionBy } from "../../../../libs/arrayUtils";

// Get from lodash git repository
const mapKeys = (object, iteratee) => {
  object = Object(object);
  const result = {};

  Object.keys(object).forEach((key) => {
    const value = object[key];
    result[iteratee(
      value, key, object
    )] = value;
  });
  return result;
};

const DownloadedTemplatesList = ({ onSelection }) => {
  const intl = useIntl();
  const dotsList = useSelector(state => state.ask.communityTemplates.templatesList);
  const templates = useSelector(state => state.ask.templates.list);
  const [isLimitCards, setLimitCards] = useState(true);
  const [orderByDate, setOrderByDate] = useState(true);
  const [orderAlphabetically, setOrderAlphabetically] = useState(false);
  const [orderAlphabeticallyReverse, setOrderAlphabeticallyReverse] = useState(false);
  const [categories, setCategories] = useState([]);
  const [activeFilter, setActiveFilter] = useState(intl.formatMessage({ id: "all"}));
  const [filteredTemplates, setFilteredTemplates] = useState([]);

  const newDotsList = dotsList.map(item => {
    return (
      mapKeys(item, (value, key) => {
        let newKey = key;
        if (key === "name") {
          newKey = "title";
        }
        return newKey;
      })
    );
  });

  const intersectionTemplates = intersectionBy(
    newDotsList, templates, "title"
  );
  useEffect(() => {
    const availableCategories = intersectionTemplates?.map(templ => templ.category);
    const uniqueCategories = [...new Set(availableCategories)];
    setCategories([intl.formatMessage({ id: "all"}), ...uniqueCategories]);
  }, [dotsList, templates, isLimitCards]);

  const moreOnOff = useIntl().formatMessage({
    id: `ask.pages.edit.chooseTemplate.${isLimitCards ? "moreOn" : "moreOff"
    }`
  });

  const filterCategories = (category) => {
    setActiveFilter(category);
    const filteredTemplatesList = intersectionTemplates?.filter(templ => {
      if (category === intl.formatMessage({ id: "all"})) {
        return intersectionTemplates;
      }
      return templ.category === category;
    });
    setFilteredTemplates(filteredTemplatesList);
  };

  const orderedTemplates = useOrderTemplates(
    filteredTemplates, orderByDate, orderAlphabetically, orderAlphabeticallyReverse, "title"
  );

  const templatesToShowRaw = orderedTemplates.length > 0 ? orderedTemplates : intersectionTemplates;

  const limit = 10;
  const templatesToShow = isLimitCards ? templatesToShowRaw.slice(0, limit) : templatesToShowRaw;

  return (
    <div className="downloadedTabContainer">
      <div className="downloadedTabHeaderContainer">
        {templatesToShow.length > 0 &&
					<div className="downloadedTabTitleContainer">
					  <h4 className="downloadedTabTitle"><FormattedMessage id="ask.pages.edit.communityTemplates.downloadedTabTitle" /></h4>
					  <h4 className="downloadedTabSubtitle"><FormattedMessage id="ask.pages.edit.communityTemplates.downloadedTabSubtitle" /></h4>
					</div>
        }
        <div
          className="askEdit-chooseTemplate-cards-more"
          // style={{ display: templatesToShow.length > 10 ? "flex" : "none" }}
        >
          <div className="downloadedTabOrderContainer">
            <CommunityTemplatesOrderSelect
              setOrderByDate={setOrderByDate}
              setOrderAlphabetically={setOrderAlphabetically}
              setOrderAlphabeticallyReverse={setOrderAlphabeticallyReverse}
            />
            <Tooltip
              title={moreOnOff}
              color={"rgb(0, 80, 117)"}
            >
              <FontAwesomeIcon
                icon={["far", "ellipsis-h"]}
                className="cards-more-icon"
                onClick={() => setLimitCards(!isLimitCards)}
              />
            </Tooltip>
          </div>
        </div>
      </div>
      <div className="downloadedTabCategoriesContainer">
        <CategoriesFilters
          categories={categories}
          activeFilter={activeFilter}
          filterCategories={filterCategories}
        />
      </div>
      <div className="downloadedTabGridContainer">
        {templatesToShow.length > 0 ?
          templatesToShow.map((dots, index) => {
            return <DownloadedDotsBlock key={`templatesToShow_${index}`} dots={dots} onSelection={onSelection} />;
          })
          : <h4 className="downloadedTabEmptyMessage"><FormattedMessage id="ask.pages.edit.communityTemplates.noDownloadedDots" /></h4>
        }
      </div>
    </div>
  );
};

export default DownloadedTemplatesList;